const heart = `
<g>
  <path transform="translate(0, -10) scale(0.1)" d="M100 160 C85 150,65 140,50 120 C35 100,30 80,35 65 C40 50,55 40,70 45 C85 50,95 65,100 72 C105 65,120 48,138 44 C155 40,170 50,172 66 C174 82,165 102,148 120 C132 138,115 150,100 160"
        stroke-width="20"/>
</g>
`;

const smiley = `
<g transform="scale(0.1) translate(60,-90) scale(1.1,1)">
  <!-- Messy face outline (scribbly) -->
  <path d="M100 25 
           C180 35, 175 170, 100 175 
           C25 170, 20 30, 100 25
           M105 28 C182 40, 178 165, 102 172"
        fill="none"
        stroke="black"
        stroke-width="15"
        stroke-linecap="round"
        stroke-linejoin="round"/>

  <!-- Left eye scribble -->
  <path d="M65 75 
           C68 78, 72 78, 70 75 
           C68 73, 65 73, 66 74 
           C67 77, 64 76, 65 75"
        fill="none"
        stroke="black"
        stroke-width="15"/>

  <!-- Right eye scribble -->
  <path d="M125 85 
           C128 88, 132 87, 130 85 
           C128 82, 125 83, 126 84 
           C127 87, 124 86, 125 85"
        fill="none"
        stroke="black"
        stroke-width="15" />

  <!-- Messy smile -->
  <path d="M60 120 
           C80 140, 120 145, 140 120
"
        fill="none"
        stroke="black"
        stroke-width="15"
        stroke-linecap="round" />
</g>
`;

export const emojis = {
    "smiley": smiley,
    "heart": heart,
};
